let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6DO1j"), load("jUhND"), load("2TjAk"), load("7ABT7"), load("8wMGm"), load("bAAmE"), load("irgIM")]).then(() => parcelRequire('cbZqw'));